import { Component, OnInit, inject } from '@angular/core';
import { WebForum } from 'src/app/forum/web-forum';
import { ForumService } from '../../forum/forum.service';

@Component({
  selector: 'app-home-forum',
  templateUrl: './home-forum.component.html',
  styleUrls: ['./home-forum.component.scss'],
  standalone: false
})
export class HomeForumComponent implements OnInit {
  private forumService = inject(ForumService);

  forums: WebForum[];
  isLoading: boolean;

  ngOnInit() {
    this.getForum();
  }

  getForum() {
    this.isLoading = true;
    this.forumService.getForums().subscribe((forums) => {
      this.isLoading = false;
      this.forums = forums;
    });
  }
}
